const state = { 
    lifeBaseData: [],
    promotionCategory:[],
    spubacklist:false
}

const mutations = {
    setLifeBase: (state, value) => {
        state.lifeBaseData = value
    },
    setpromotionCategory: (state, value) => {
        state.promotionCategory = value
    },
    setspubacklist: (state, value) => {
        state.spubacklist = value
    }
}

export default {
    namespaced: true,
    state,
    mutations
}